(function() {

        const regform = document.getElementById("create_customer");
        const loginform = document.getElementById("customer_login");
        if(regform){
          var passwordInput = document.getElementById("RegisterForm-password");
        }else{
          var passwordInput = document.getElementById("CustomerPassword");
        }
        
        
        // This variable stores the actual password entered by the user
        if(passwordInput) {
            let actualPassword = "";
            // Timer for delaying the re-masking
            let timerId = null;
            
            passwordInput.addEventListener("input", function(e) {
              // Clear any previous timer to prevent premature masking
              if (timerId) {
                clearTimeout(timerId);
              }
              
              // Determine whether the event was a deletion or addition
              // When using type="password", e.data is typically available for additions
              if (e.inputType === "deleteContentBackward") {
                // For deletion, remove the last character from actualPassword
                actualPassword = actualPassword.slice(0, -1);
              } else {
                // For addition, use the inserted character (if available)
                if (e.data) {
                  actualPassword += e.data;
                }
              }
              
              // Temporarily change the input type to text so we can control the displayed value
              passwordInput.type = "text";
              
              // Construct the display value: all characters masked except the last one
              let displayVal = "";
              if (actualPassword.length === 1) {
                displayVal = actualPassword;
              } else if (actualPassword.length > 1) {
                displayVal = "*".repeat(actualPassword.length - 1) + actualPassword.slice(-1);
              }
              passwordInput.value = displayVal;
              
              // After 1 second, switch the field back to type "password"
              timerId = setTimeout(function() {
                passwordInput.type = "password";
                // Reset the value. The browser will mask it automatically.
                passwordInput.value = actualPassword;
              }, 1000);

            });
        }
        let input = document.getElementsByName("customer[password]");
        let btn = document.getElementById("eye-icon");
        if(btn){
        btn.addEventListener("click", function() {
            if (input[0].type === "password") {
                input[0].type = "text";
                btn.textContent = "Hide";
            }
            else {
                input[0].type = "password";
                btn.textContent = "Show";
            }
        })
        }
    })();